import { cn } from '@/lib/utils';

interface LogoProps {
  /** Pixel size of the square icon mark. Default 40. */
  size?: number;
  /** Show the "Life Movie Maker" wordmark next to the mark. */
  showWordmark?: boolean;
  /** Extra classes for the wrapper. */
  className?: string;
  /** Wordmark text size class (Tailwind). Default text-xl. */
  wordmarkClassName?: string;
}

/**
 * App logo: the clapperboard + magic-wand mark (public/favicon.svg), optionally
 * with the wordmark. The SVG is the single source of truth generated by
 * branding/generate.mjs — see docs/LOGO-AND-ICONS.md.
 */
export function Logo({
  size = 40,
  showWordmark = false,
  className,
  wordmarkClassName,
}: LogoProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <img
        src="/favicon.svg"
        width={size}
        height={size}
        alt="Life Movie Maker"
        className="rounded-[22%] shadow-lg shrink-0"
        style={{ width: size, height: size }}
        draggable={false}
      />
      {showWordmark && (
        <span
          className={cn(
            'font-extrabold tracking-tight text-white drop-shadow',
            wordmarkClassName ?? 'text-xl',
          )}
        >
          Life Movie Maker
        </span>
      )}
    </div>
  );
}

export default Logo;
